var _polygon, _path, _rect, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTwitch(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 2400 2800",
    role: "img",
    "aria-label": "Twitch",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "2200,1300 1800,1700 1400,1700 1050,2050 1050,1700 600,1700 600,200 2200,200"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#9146FF",
    d: "M500,0L0,500v1800h600v500l500-500h400l900-900V0L500,0z M2200,1300l-400,400h-400l-350,350v-350H600V200h1600V1300z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1700,
    y: 550,
    fill: "#9146FF",
    width: 200,
    height: 600
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1150,
    y: 550,
    fill: "#9146FF",
    width: 200,
    height: 600
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitch);
export default __webpack_public_path__ + "static/media/twitch.1bd70117a43a2b3520ae1f48e4707627.svg";
export { ForwardRef as ReactComponent };